var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPlace = function SvgIcPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F67600",
    fillRule: "evenodd",
    d: "M10.119 21.762a33 33 0 0 1-2.007-2.187c-1.777-2.123-3.887-5.284-3.887-8.296a7.775 7.775 0 0 1 13.275-5.5 7.73 7.73 0 0 1 2.274 5.5c0 3.012-2.11 6.173-3.887 8.296a33 33 0 0 1-2.007 2.187 2.656 2.656 0 0 1-3.761 0M12 14.501a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
export default SvgIcPlace;